import { SpacesLayoutMode } from "./types";

export const SPACES_LAYOUT_MODE_LOCAL_STORAGE_KEY = "spaces-layout-mode-v2";
export const DEFAULT_SPACES_LAYOUT_MODE = SpacesLayoutMode.List;

/*
 * The diagram mounts a node per space, and each node eagerly mounts several
 * floating-ui controls (tooltip, popover, dropdown). At a few thousand spaces
 * that mount storm freezes the tab for seconds, so above this many spaces we
 * render a truncated graph and steer people to the List view instead.
 *
 * 100 is a deliberately conservative cap rather than a measured threshold: it's
 * small enough that the mount cost stays negligible and the tree is still
 * readable on screen. The exact number isn't load-bearing - the diagram's value
 * drops off quickly as the hierarchy grows, so we err low and let the List view
 * (which scales fine) handle large accounts.
 */
export const SPACES_DIAGRAM_NODE_LIMIT = 100;

export const CREATE_NEW_URL_PARAM = "create-new";
export const PARENT_ID_URL_PARAM = "parentId";
export const FILTERS_ORDER_SETTINGS_KEY = "spacesFiltersOrder";

export const INTERACTIVE_ATTRIBUTE_FOR_DRAWER = "data-space-node-element-interactive";
